export type UserRole = 'admin' | 'agency' | 'trainer' | 'user';

export interface RoutePermission {
    allowedRoles: UserRole[];
    requiredRole?: UserRole;
}

export const ROLE_PERMISSIONS = {
    // Admin can access everything
    ADMIN: ['admin'] as UserRole[],

    // Agency can access agency-specific and some common features
    AGENCY: ['admin', 'agency'] as UserRole[],

    // Trainer can access trainer-specific and some common features
    TRAINER: ['admin', 'agency', 'trainer'] as UserRole[],

    // Common features accessible by multiple roles
    COMMON: ['admin', 'agency', 'trainer'] as UserRole[],

    // User-specific (clients)
    USER: ['admin', 'agency', 'trainer', 'user'] as UserRole[],
} as const;

/**
 * Check if a user role has permission to access a route
 */
export const hasPermission = (userRole: UserRole | null, allowedRoles: UserRole[]): boolean => {
    if (!userRole) return false;
    return allowedRoles.indexOf(userRole) !== -1;
};

/**
 * Filter routes based on user role
 */
export const filterRoutesByRole = (routes: any[], userRole: UserRole | null) => {
    if (!userRole) return [];

    return routes.filter(route => {
        if (!route.allowedRoles) return true; // If no permissions defined, allow access
        return hasPermission(userRole, route.allowedRoles);
    });
};
